import { chipEntityIconSvg } from './entityIconSources';

import type { TagVariant } from '~/shared/components/Tag';

export interface EntityChipStyle {
  bg: string;
  fg: string;
  label: string;
}

export const ENTITY_CHIP_STYLES: Record<string, EntityChipStyle> = {
  account: { bg: '#F5F6F8', fg: '#828B98', label: 'Account' },
  cluster: { bg: 'var(--color-magnolia)', fg: 'var(--color-vivd-purple)', label: 'Cluster' },
  nodeGroup: {
    bg: 'var(--color-pale-yellow)',
    fg: 'var(--color-carrot-orange)',
    label: 'Node Group',
  },
  instance: { bg: 'var(--color-primary-100)', fg: 'var(--color-primary-600)', label: 'Instance' },
  ec2: { bg: 'var(--color-primary-100)', fg: 'var(--color-primary-600)', label: 'EC2 Instances' },
  region: { bg: '#F5F6F8', fg: '#828B98', label: 'Region' },
  tag: { bg: 'var(--color-primary-50)', fg: '#828B98', label: 'Tag' },
  unattached: { bg: 'var(--color-pale-pink)', fg: 'var(--color-deep-pink)', label: 'Unattached' },
  status: { bg: '#F5F6F8', fg: '#5C6380', label: 'Status' },
  reason: { bg: '#F5F6F8', fg: '#5C6380', label: 'Reason' },
  volume: { bg: '#FBFCFC', fg: '#5C6380', label: 'Volume' },
  overflow: { bg: '#F5F6F8', fg: '#5C6380', label: 'Overflow' },
};

export function getEntityChipStyle(type: string): EntityChipStyle {
  return (
    ENTITY_CHIP_STYLES[type] ?? {
      bg: '#F5F6F8',
      fg: '#5C6380',
      label: type || '',
    }
  );
}

export function entityTypeToTagVariant(type: string): TagVariant {
  switch (type) {
    case 'cluster':
      return 'cluster';
    case 'nodeGroup':
      return 'node';
    case 'instance':
    case 'ec2':
      return 'instance';
    case 'account':
      return 'account';
    default:
      return 'gray';
  }
}

export function entityIconSvg(type: string): string {
  return chipEntityIconSvg(type);
}
